import createSelector from 'web-app/util/custom-create-selector';
import AccountBehaviorIds from 'web-app/behaviors/account-behavior-ids';
import FamlyticsBehaviors from 'web-app/behaviors/famlytics-behavior-ids';
import LocalStorageService from 'web-app/services/local-storage';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import {hasValue} from '@famly/stat_ts-utils_has-value';
import BillingOverviewBehaviors from 'web-app/behaviors/billing-overview-behavior-ids';
import PlatformHelper from 'web-app/helpers/platform-helper';
import {isNonEmpty} from 'web-app/util/non-empty-array';
import MainNavigationBehaviorIds from 'web-app/behaviors/main-navigation-behavior-ids';

export const getAccount = state => state.session.account;
const getAccountFeatures = state => state.session.account.features;
export const getAccountBehaviors = createSelector(
    state => state.session.account.behaviors,
    behaviors => {
        return new BehaviorsCollection(behaviors);
    },
);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getRoles2 = state => state.session.account.roles2;

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
const isDaycareParent = role2 =>
    role2.sourceType === 'Famly.Daycare:Relation' && role2.targetType === 'Famly.Daycare:Child';

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
const isDaycareEmployeeRole = role2 =>
    role2.sourceType === 'Famly.Daycare:Employee' && role2.targetType === 'Famly.Daycare:Employee';

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
const isOrganizationPerson = role2 =>
    role2.sourceType === 'Famly.Daycare:OrganizationPerson' && role2.targetType === 'Famly.Daycare:Organization';

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
const isInstitutionRole = role2 =>
    role2.sourceType === 'Famly.Daycare:Employee' && role2.targetType === 'Famly.Daycare:Institution';

export const canLoginWithPin = state => state.session.account && state.session.account.loginWithPin;

export const getLoginId = state => state.session.account?.loginId;

export const getFirstName = state => state.session.account?.name?.firstName;

export const getLastName = state => state.session.account?.name?.lastName;

export const getLocale = state => state.session.account && state.session.account.locale;

export const getEmail = state => state.session.account && state.session.account.email;

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getInstitutionIds = createSelector(getRoles2, roles2 =>
    roles2.map(role => (role.targetType.includes('Institution') ? role.targetId : null)).filter(a => a),
);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getOrganizationIds = createSelector(getRoles2, roles2 =>
    roles2.map(role => (role.targetType.includes('Organization') ? role.targetId : null)).filter(a => a),
);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getChildRoles = createSelector(getRoles2, roles2 => {
    if (roles2 && roles2.length !== 0) {
        return roles2.filter(isDaycareParent);
    } else {
        return [];
    }
});

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getIsParent = createSelector(getChildRoles, roles => roles.length > 0);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getEmployeeRoles = createSelector(getRoles2, roles2 => {
    if (roles2 && roles2.length !== 0) {
        return roles2.filter(isDaycareEmployeeRole);
    } else {
        return [];
    }
});

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
const getOrganizationRoles = createSelector(getRoles2, roles2 => {
    if (roles2 && roles2.length !== 0) {
        return roles2.filter(isOrganizationPerson);
    } else {
        return [];
    }
});

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getInstitutionRoles = createSelector(getRoles2, roles => {
    if (hasValue(roles) && isNonEmpty(roles)) {
        return roles.filter(isInstitutionRole);
    }
    return [];
});

export const getTimezone = createSelector(getAccount, account => account && account.timeZone);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getIsEmployee = createSelector(getEmployeeRoles, roles => roles.length > 0);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getIsOrganizationPerson = createSelector(getOrganizationRoles, roles => roles.length > 0);

export const canSendPosts = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShowNewPost),
);

/*
    shouldUseElevio selector is renamed shouldUseIntercom because we are not using Elevio anymore
    the account behavior id remains 'EnableElevio' because that is the name of the behavior we
    receive from the backend on me/me/me
*/
export const shouldUseIntercom = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.EnableElevio),
);

export const scaleImagesBeforeUpload = createSelector(getAccountBehaviors, behaviors => {
    if (hasValue(LocalStorageService.getFromLocalStorage('imageCompressionForced'))) {
        return LocalStorageService.getFromLocalStorage('imageCompressionForceQuality');
    }
    return behaviors.includes(AccountBehaviorIds.ScaleImagesBeforeUploading);
});
const desiredImageQuality = createSelector(getAccountBehaviors, behaviors => {
    if (hasValue(LocalStorageService.getFromLocalStorage('imageCompressionForceQuality'))) {
        return LocalStorageService.getFromLocalStorage('imageCompressionForceQuality');
    }
    return behaviors.behaviorForId(AccountBehaviorIds.ScaleImagesBeforeUploading)?.payload?.quality;
});
const maxImageDimension = createSelector(getAccountBehaviors, behaviors => {
    if (hasValue(LocalStorageService.getFromLocalStorage('imageCompressionForceMaxDimension'))) {
        return LocalStorageService.getFromLocalStorage('imageCompressionForceMaxDimension');
    }
    return behaviors.behaviorForId(AccountBehaviorIds.ScaleImagesBeforeUploading)?.payload?.maxDimension;
});

export const fallbackImageCompressionConfig = {
    enabled: false,
    quality: undefined,
    maxDimension: undefined,
};

export const imageScalingConfig = createSelector(
    scaleImagesBeforeUpload,
    desiredImageQuality,
    maxImageDimension,
    (shouldCompress, quality, maxDimension) => {
        if (!hasValue(shouldCompress) && !hasValue(quality) && !hasValue(maxDimension)) {
            return fallbackImageCompressionConfig;
        }
        return {
            enabled: hasValue(shouldCompress) ? shouldCompress : fallbackImageCompressionConfig.enabled,
            quality: hasValue(quality) ? quality / 100 : fallbackImageCompressionConfig.quality,
            maxDimension: hasValue(maxDimension) ? maxDimension : fallbackImageCompressionConfig.maxDimension,
        };
    },
);

export const analyticsBehavior = createSelector(getAccountBehaviors, behaviors =>
    behaviors.behaviorForId(FamlyticsBehaviors.EnableAnalytics),
);

export const showNewObservation = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShowNewObservation),
);

export const showNewObservation2021Revision = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShowObservations2021Revision),
);

export const showNewObservationPre2021Revision = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShowObservationsPre2021Revision),
);

export const signInModalType = createSelector(
    state => state.session.account,
    getAccountBehaviors,
    (account, behaviors) => {
        const isGPSSignInEnabled =
            behaviors.includes(AccountBehaviorIds.CanSignChildrenInWithGPS) ||
            behaviors.includes(AccountBehaviorIds.CanSignEmployeesInWithGPS);
        const showQRSignIn = !PlatformHelper.isMobileApp() ? false : Boolean(account?.isQrSigninEnabled);
        // This will prevent Sign in/out option from showing on desktop if both GPS and QR are enabled
        const showGPSSignIn = isGPSSignInEnabled && !account?.isQrSigninEnabled;
        return {
            showGPSSignIn,
            showQRSignIn,
        };
    },
);

export const showPreviousChildren = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShowPreviousChildren),
);

export const shouldReplyToNps = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShouldReplyToNps),
);

export const hasTwoFactorAuthentication = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.HasTwoFactorAuthentication),
);

export const canActivateTwoFactorAuthentication = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.CanActivateTwoFactorAuthentication),
);

export const showFamlyBilling = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(BillingOverviewBehaviors.ShowFamlyBilling),
);

export const canLinkToActivityInPost = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.CanLinkToActivityInPost),
);

export const canJoinFamlyLiveMeetingsFromWeb = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.CanJoinFamlyLiveMeetingsFromWeb),
);

export const canJoinFamlyLiveMeetingsFromAndroid = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.CanJoinFamlyLiveMeetingsFromAndroid),
);

export const canJoinFamlyLiveMeetingsFromIOs = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.CanJoinFamlyLiveMeetingsFromIOs),
);

export const canStartFamlyLiveMeetings = createSelector(
    getAccountBehaviors,
    canJoinFamlyLiveMeetingsFromWeb,
    canJoinFamlyLiveMeetingsFromAndroid,
    canJoinFamlyLiveMeetingsFromIOs,
    (behaviors, canJoinFromWeb, canJoinFromAndroid, canJoinFromIOs) => {
        if (PlatformHelper.isWeb() && !canJoinFromWeb) {
            return false;
        }

        if (PlatformHelper.isAndroid() && !canJoinFromAndroid) {
            return false;
        }

        if (PlatformHelper.isIos() && !canJoinFromIOs) {
            return false;
        }

        return behaviors.includes(AccountBehaviorIds.CanStartFamlyLiveMeetings);
    },
);

export const make2021RevisionObservationInstitutionIds = () =>
    createSelector(showNewObservation2021Revision, getAccountBehaviors, (showNewObservation2021Revision, behaviors) =>
        showNewObservation2021Revision
            ? behaviors.behaviorForId(AccountBehaviorIds.ShowObservations2021Revision).payload.institutionIds
            : [],
    );

export const makePre2021RevisionObservationInstitutionIds = () =>
    createSelector(
        showNewObservationPre2021Revision,
        getAccountBehaviors,
        (showNewObservationPre2021Revision, behaviors) =>
            showNewObservationPre2021Revision
                ? behaviors.behaviorForId(AccountBehaviorIds.ShowObservationsPre2021Revision).payload.institutionIds
                : [],
    );

export const hasVideo = createSelector(getAccountFeatures, features => features.indexOf('VIDEO') >= 0);

export const accountImageSmall = createSelector(
    state => state.session.account,
    account => (account && account.image ? account.image.small : null),
);

export const showDebugLink = createSelector(
    state => state.session.account,
    account => account?.email?.endsWith?.('@famly.co'),
);

export const loginId = state => state.session.account.loginId;
export const secret = state => state.session.account.localSecret;

export const showStarTab = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ConversationShowStarTab),
);

export const showAllTab = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ConversationShowAllTab),
);

export const profileImage = createSelector(
    state => state.session.account,
    account => account.image,
);

export const intercomV2 = createSelector(
    state => state.session.account,
    account => account._intercomV2,
);

export const fullName = createSelector(
    state => state.session.account,
    account => account && account.name && account.name.fullName,
);

export const shouldUseUserContext = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.UseUserContextAuthentication),
);

export const canUnsubscribeFromOrgSender = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.CanUnsubscribeFromOrgSender),
);

export const getMainNavigationBehaviors = createSelector(
    state => state.mainNavigation.behaviors,
    behaviors => behaviors,
);
export const showFamlyStore = createSelector(getMainNavigationBehaviors, behaviors =>
    behaviors.includes(MainNavigationBehaviorIds.ShowFamlyStore),
);

/**
 * @deprecated This function depends on the 'roles2' property from the /me/me/me endpoint, which is deprecated
 *             If need this information to decide on e.g. toggling features / buttons / elements / logic
 *             you likely want to talk to the backend about how to get this information elsewhere.
 */
export const getIsOnlyParent = createSelector(
    getIsEmployee,
    getIsParent,
    getIsOrganizationPerson,
    (isEmployee, isParent, isOrganizationPerson) => isParent && !isEmployee && !isOrganizationPerson,
);

export const showActiveTrialSubscriptionsPayload = createSelector(getAccountBehaviors, behaviors => {
    return behaviors.behaviorForId(AccountBehaviorIds.ShowActiveTrialSubscriptions)?.payload ?? null;
});

export const showOverduePaymentBanner = createSelector(getAccountBehaviors, behaviors =>
    behaviors.includes(AccountBehaviorIds.ShowOverduePaymentBanner),
);
